module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_vm._v("Writing a book … compels you to want to sum up your life … I’m not going to give in to that urge. Let someone else sum up my life when it’s over.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—L")]), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("ARRY")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" H")]), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("AGMAN")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("IN")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("POSTSCRIPT")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("TO")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("HIS")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-SC-I"
  }, [_vm._v("AUTOBIOGRAPHY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0